import styled, { css } from 'styled-components/macro';
import { ADAPTIVE } from '@yme/tokens/screen';
const buildFlexWrapperCssOptions = ({ prop, mobile, tablet, desktop, general, }) => css `
  ${() => general && prop && `${prop}: ${general};`}

  ${() => prop &&
    mobile &&
    css `
      ${ADAPTIVE.minWidth.mobile} {
        ${`${prop}: ${mobile};`}
      }
    `}

  ${() => prop &&
    tablet &&
    css `
      ${ADAPTIVE.minWidth.tablet} {
        ${`${prop}: ${tablet};`}
      }
    `}

  ${() => prop &&
    desktop &&
    css `
      ${ADAPTIVE.minWidth.desktop} {
        ${`${prop}: ${desktop};`}
      }
    `}
`;
export const FlexWrapper = styled.div `
  display: flex;

  box-sizing: border-box;

  ${({ marginMobile, marginTablet, marginDesktop, margin }) => buildFlexWrapperCssOptions({
    prop: 'margin',
    mobile: marginMobile,
    tablet: marginTablet,
    desktop: marginDesktop,
    general: margin,
})};

  ${({ mtMobile, mtTablet, mtDesktop, mt }) => buildFlexWrapperCssOptions({
    prop: 'margin-top',
    mobile: mtMobile,
    tablet: mtTablet,
    desktop: mtDesktop,
    general: mt,
})};

  ${({ mrMobile, mrTablet, mrDesktop, mr }) => buildFlexWrapperCssOptions({
    prop: 'margin-right',
    mobile: mrMobile,
    tablet: mrTablet,
    desktop: mrDesktop,
    general: mr,
})};

  ${({ mbMobile, mbTablet, mbDesktop, mb }) => buildFlexWrapperCssOptions({
    prop: 'margin-bottom',
    mobile: mbMobile,
    tablet: mbTablet,
    desktop: mbDesktop,
    general: mb,
})};

  ${({ mlMobile, mlTablet, mlDesktop, ml }) => buildFlexWrapperCssOptions({
    prop: 'margin-left',
    mobile: mlMobile,
    tablet: mlTablet,
    desktop: mlDesktop,
    general: ml,
})};

  ${({ ptMobile, ptTablet, ptDesktop, pt }) => buildFlexWrapperCssOptions({
    prop: 'padding-top',
    mobile: ptMobile,
    tablet: ptTablet,
    desktop: ptDesktop,
    general: pt,
})};

  ${({ pbMobile, pbTablet, pbDesktop, pb }) => buildFlexWrapperCssOptions({
    prop: 'padding-bottom',
    mobile: pbMobile,
    tablet: pbTablet,
    desktop: pbDesktop,
    general: pb,
})};

  ${({ plMobile, plTablet, plDesktop, pl }) => buildFlexWrapperCssOptions({
    prop: 'padding-left',
    mobile: plMobile,
    tablet: plTablet,
    desktop: plDesktop,
    general: pl,
})};

  ${({ prMobile, prTablet, prDesktop, pr }) => buildFlexWrapperCssOptions({
    prop: 'padding-right',
    mobile: prMobile,
    tablet: prTablet,
    desktop: prDesktop,
    general: pr,
})};

  ${({ paddingMobile, paddingTablet, paddingDesktop, padding }) => buildFlexWrapperCssOptions({
    prop: 'padding',
    mobile: paddingMobile,
    tablet: paddingTablet,
    desktop: paddingDesktop,
    general: padding,
})};

  ${({ pr }) => pr && `padding-right: ${pr};`}
  ${({ pl }) => pl && `padding-left: ${pl};`}

  ${({ gap }) => gap && `gap: ${gap};`}
  ${({ alignSelf }) => alignSelf && `align-self: ${alignSelf};`}
  ${({ alignItems }) => alignItems && `align-items: ${alignItems};`}
  ${({ flexDirection }) => flexDirection && `flex-direction: ${flexDirection};`}
  ${({ justifyContent }) => justifyContent && `justify-content: ${justifyContent};`}
  ${({ flexWrap }) => flexWrap && `flex-wrap: ${flexWrap};`}
  ${({ flexShrink }) => flexShrink && `flex-shrink: ${flexShrink};`}

  ${({ position }) => position && `position: ${position};`}

  ${({ bg }) => bg && `background-color: ${bg};`}
  ${({ height }) => height && `height: ${height};`}
  ${({ minHeight }) => minHeight && `min-height: ${minHeight};`}
  ${({ isFullWidth }) => isFullWidth && 'width: 100%;'}

  ${({ aspectRatio }) => aspectRatio && `aspect-ratio: ${aspectRatio};`}
  ${({ flex }) => flex && `flex: ${flex};`}

  ${({ textAlign }) => textAlign && `text-align: ${textAlign};`}
  ${({ filter }) => filter && `filter: ${filter};`}

  ${({ overflow }) => overflow && `overflow: ${overflow};`}

  ${({ isRightToLeft }) => isRightToLeft && 'direction: rtl;'}
`;
export const ComponentHolder = styled.div `
  ${({ position }) => position && `position: ${position};`}

  ${({ bg }) => bg && `background: ${bg};`}

  transition: background 150ms;

  ${({ p }) => p && `padding: ${p};`}
  ${({ m }) => m && `margin: ${m};`}
  
  ${({ overflow }) => overflow && `overflow: ${overflow};`}
`;
